import { React, useEffect, useState, useRef } from 'react';
import { Link, Outlet, Route, useNavigate } from 'react-router-dom';
import ROUTES from '../../nav/Routes';
import { useFormik } from 'formik';
import axios from 'axios';

function Contact() {
    const [messageSent, setMessageSent] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            subject: '',
            msg: ''
        },
        validate: values => {
            const errors = {};
            if (!values.name) errors.name = "Name is required";
            if (!values.email) {
                errors.email = "Email is required";
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                errors.email = "Invalid email address";
            }
            if (!values.subject) errors.subject = "Subject is required";
            if (!values.msg) errors.msg = "Message is required";
            return errors;
        },
        onSubmit: async values => {
            setIsSubmitting(true);
            setErrorMessage('');
            setMessageSent(false);

            try {
                const response = await axios.post(
                    "http://localhost:8080/mann/contactPost.php",
                    values,
                    {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                );

                if (response.data.success) {
                    formik.resetForm();
                    // alert("Message Sent Thank you!")
                    setMessageSent(true);
                } else {
                    setErrorMessage(response.data.message || "Message sending failed");
                }
            } catch (error) {
                console.error("Contact error:", error);
                setErrorMessage("Something went wrong. Please try again.");
            } finally {
                setIsSubmitting(false);
            }
        }
    });




    return (
        <>
            <div id="hero" className="Starter section dark-background">
                <img src="assets/img/image2.jpg" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" data-aos="fade-in" />
                <div className="container">
                    <div className="row justify-content-center text-center" data-aos="fade-up" data-aos-delay="100">
                        <div className="col-xl-6 col-lg-8">
                            <h2>Let’s Get in Touch<span>.</span></h2>
                            <p>We’re here to assist you. Reach out for queries, support, or to partner with us on your logistics needs.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-offwhite py-5">
                <div id="contact" className="contact custom my-5">
                    <div className="container" data-aos="fade-up" data-aos-delay="100">
                        <div className="row gy-4">
                            <div className="col-lg-4">

                                <div className="container section-title pb-4" data-aos="fade-up">
                                    <h2>Contact</h2>
                                    <p>Contact Us</p>
                                </div>

                                <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="400">
                                    <i className="bi bi-telephone flex-shrink-0"></i>
                                    <div>
                                        <h3>Call Us</h3>
                                        <p>+1 5164562280</p>
                                    </div>
                                </div>

                                <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="500">
                                    <i className="bi bi-envelope flex-shrink-0"></i>
                                    <div>
                                        <h3>Email Us</h3>
                                        <p>info@manncarriers.com</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-8">
                                <form onSubmit={formik.handleSubmit} className="php-email-form" data-aos="fade-up" data-aos-delay="200">
                                    {messageSent && (
                                        <div className="mb-4 alert alert-success ">
                                            <div className="text-success">
                                                <i class="bi bi-check-circle-fill me-2"></i> Thank you so much for reaching out to us! We've successfully received your message and truly appreciate you taking the time to connect. Our team will get back to you as soon as possible!
                                            </div>
                                        </div>
                                    )}
                                    {errorMessage && (
                                        <div className="mb-4 alert alert-danger ">
                                            <div className="text-danger">
                                                <i class="bi bi-exclamation-triangle-fill me-2"></i> {errorMessage}
                                            </div>
                                        </div>
                                    )}
                                    <div className="row gy-4">
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control form-control-lg"
                                                placeholder="Your Name"
                                                onChange={formik.handleChange}
                                                value={formik.values.name}
                                            />
                                            {formik.errors.name && (
                                                <div className="small text-danger mt-2">{formik.errors.name}</div>
                                            )}
                                        </div>

                                        <div className="col-md-6">
                                            <input
                                                type="email"
                                                className="form-control form-control-lg"
                                                name="email"
                                                placeholder="Your Email"
                                                onChange={formik.handleChange}
                                                value={formik.values.email}
                                            />
                                            {formik.errors.email && (
                                                <div className="small text-danger mt-2">{formik.errors.email}</div>
                                            )}
                                        </div>

                                        <div className="col-md-12">
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                name="subject"
                                                placeholder="Subject"
                                                onChange={formik.handleChange}
                                                value={formik.values.subject}
                                            />
                                            {formik.errors.subject && (
                                                <div className="small text-danger mt-2">{formik.errors.subject}</div>
                                            )}
                                        </div>

                                        <div className="col-md-12">
                                            <textarea
                                                className="form-control form-control-lg"
                                                name="msg"
                                                rows="6"
                                                placeholder="Message"
                                                onChange={formik.handleChange}
                                                value={formik.values.msg}
                                            ></textarea>
                                            {formik.errors.msg && (
                                                <div className="small text-danger mt-2">{formik.errors.msg}</div>
                                            )}

                                        </div>

                                        <div className="col-md-12">
                                            {isSubmitting && <div className="loading">Loading</div>}
                                            {errorMessage && <div className="error-message">{errorMessage}</div>}

                                            <button
                                                type="submit"
                                                className="submit-btn"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? 'Submitting...' : 'Send Message'}
                                                <i className="bi bi-arrow-right"></i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default Contact;